module.exports = __webpack_public_path__ + "static/media/room-09.a0649dcd.jpg";